const ROOT = 'StepTwo/myPackageAvailable';

export const FETCH_MY_PACKAGE_AVAILABLE_REQUEST = `${ROOT}/FETCH_MY_PACKAGE_AVAILABLE_REQUEST`;
export const FETCH_MY_PACKAGE_AVAILABLE_FAILURE = `${ROOT}/FETCH_MY_PACKAGE_AVAILABLE_FAILURE`;
export const FETCH_MY_PACKAGE_AVAILABLE_SUCCESS = `${ROOT}/FETCH_MY_PACKAGE_AVAILABLE_SUCCESS`;

export const SET_MY_PACKAGE_AVAILABLE_ALL = `${ROOT}/SET_MY_PACKAGE_AVAILABLE_ALL`;
export const SET_MY_PACKAGE_AVAILABLE_BY_CHANNEL = `${ROOT}/SET_MY_PACKAGE_AVAILABLE_BY_CHANNEL`;
export const SET_MY_PACKAGE_AVAILABLE_TOTAL = `${ROOT}/SET_MY_PACKAGE_AVAILABLE_TOTAL`;
export const CLEAR_MY_PACKAGE_AVAILABLE_ALL = `${ROOT}/CLEAR_MY_PACKAGE_AVAILABLE_ALL`;
export const SET_MY_PACKAGE_AVAILABLE_BOTH = `${ROOT}/SET_MY_PACKAGE_AVAILABLE_BOTH`;